<template lang='pug'>
  v-card
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card(style="border: solid 1px")
        v-card-title
          | Anular devolución
          v-spacer
            v-icon(aria-label="Close" @click="confirmationDialog = false")
              | mdi-close
        v-card-text.body-1.text-center
          | Esta seguro que desea anular esta devolución?
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', :loading="isCanceling" @click.native='cancelReturn()') Si, proceder
    v-snackbar(v-model='snackbar.show' centered :color='snackbar.color' right top :timeout="5000")
      | {{snackbar.message}}
      v-btn(dark='' text='' @click='snackbar.show = false')
        | Cerrar
    v-card-title
      | Factura # {{item.reference_number}}
      v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
    v-card-subtitle(v-if="item.type !=='purchases' && item.type !== 'expenses'").mt-2
      | {{item.location_from.name}}
    v-card-text.body-1.text-center.mt-4
      v-form(ref="form" v-model="valid" lazy-validation)
        v-row(:style="isMobile ? 'overflow-x:auto;' : ''")
          table().ma-auto
            thead
              tr
                th.text-xs-left Cantidad
                th.text-xs-left Referencia
                th.text-xs-left Valor/Unidad
                th.text-xs-left Valor total
                th.text-xs-left Enviar a inventario
                th.text-xs-left Retirar producto
            tbody
              tr(v-for='row in item.products')
                th.text-xs-left {{row.qty}}
                td.text-xs-left(style='max-width: 100px;')
                  a(@click.stop="showProduct(row)") {{row.name}}
                td(v-if="currentType !== 'transfers'").text-xs-left {{row.price}}
                th.text-xs-left {{row.price * row.qty | numberFormat}}
                th(v-if="row.type !== 'service'")
                  v-text-field(label="Cantidad" type="number" v-model='row.stock'  :rules="[rules.required]" :disabled="item.status === 'approved' || item.status === 'rejected'" @keyup="handleStock(row, 'stock')" @click="handleStock(row, 'stock')" min="0" :max="row.qty")
                th(v-if="row.type !== 'service'")
                  v-text-field(label="Cantidad" type="number" v-model='row.trash'  :rules="[rules.required]" :disabled="item.status === 'approved' || item.status === 'rejected'" @keyup="handleStock(row, 'trash')" @click="handleStock(row, 'trash')" min="0" :max="row.qty")
          v-row.justify-space-around
              v-col
                span Total devolucion
                  b.ml-2 {{item.total}}
              p.red--text.d-flex.align-center(v-if="item.status === 'rejected'") Devolucion rechazada
              v-col
                v-btn.mt-6(v-if="item.status === 'pending'" color="info" depressed="" default="" rounded="" @click="updateReturn") Aprobar
                v-btn.mt-6(v-if="item.status === 'pending'" color="info" depressed="" default="" rounded="" @click="openDeleteDialog") Anular
        v-btn.mt-6(color="info" depressed="" default="" rounded="" @click="$emit('close')")
          | Ok

</template>

<script>
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'BillPreview',
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },

    },
    props: {
      item: Object,
      currentType: String,
    },
    data: function () {
      return {
        confirmationDialog: false,
        valid: false,
        rules: {
          required: value => ((/^[0-9]*$/.test(value)) && value !== '') || 'El campo es requerido.',
        },
        isCanceling: false,
        snackbar: {
          show: false,
          message: '',
          color: 'red',
        },
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    mounted () {
      // this.item.products.forEach(producto => {
      //   producto.stock = 0
      //   producto.trash = producto.qty
      // })
    },
    methods: {
      openDeleteDialog () {
        const vm = this
        vm.confirmationDialog = true
      },
      showSnackbar (color, message) {
        const vm = this
        vm.snackbar.color = color
        vm.snackbar.message = message
        vm.snackbar.show = true
      },
      cancelReturn () {
        const vm = this
        vm.isCanceling = true
        const data = {
          item: vm.item,
          type: 'returns',
        }
        vm.$store.dispatch('transactions/cancelItem', data).then(function () {
          vm.isCanceling = false
          vm.item.status = 'rejected'
          vm.confirmationDialog = false
          vm.showSnackbar('success', 'Devolución cancelada exitosamente')
        })
      },
      showSupportImage (item) {
        this.$emit('showSupportImage', item)
      },
      showProduct (item) {
        const vm = this
        vm.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.$emit('showProduct')
        })
      },
      handleStock (val, type) {
        const trash = parseInt(val.trash)
        const qty = parseInt(val.qty)
        const stock = parseInt(val.stock)
        if (!Number.isNaN(trash) && !Number.isNaN(qty) && !Number.isNaN(stock)) {
          if (type === 'stock') {
            const value = qty - stock
            if (Number.isInteger(value) && value >= 0 && stock >= 0) {
              val.stock = stock
              val.trash = value
            } else {
              val.stock = qty
              val.trash = 0
            }
          } else {
            const value = qty - trash
            if (Number.isInteger(value) && value >= 0 && trash >= 0) {
              val.trash = trash
              val.stock = value
            } else {
              val.trash = qty
              val.stock = 0
            }
          }
        } else {
          val.stock = 0
          val.trash = qty
        }
      },
      updateReturn () {
        const vm = this
        if (vm.$refs.form.validate()) {
          if (vm.item.products.some((product) => {
            if (product.stock + product.trash <= product.qty) {
              return true
            } else {
              return false
            }
          })) {
            vm.$store.dispatch('transactions/updateReturn', vm.item).then(function () {
              vm.$emit('close')
            })
          } else {
            // No dejar pasar
          }
        }
      },
    },

  }
</script>

<style scoped>
</style>
